export const handleMapToOptions = (array, label, value = null) =>
	array?.map((element) => ({
		label: element[label],
		value: value ? element[value] : element,
		isActive: element.is_active,
	})) || [];
